import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SystemProvider {
  constructor(private httpClient: HttpClient) {}

  status(): Observable<any> {
    return this.httpClient.get("/api/status");
  }

  settings(): Observable<any> {
    return this.httpClient.get("/api/settings");
  }
}
